// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggler[data-v-aff1ae70]{width:35px;height:18px;background:#2a3946;position:relative;transition:.4s;cursor:pointer}.toggler.active[data-v-aff1ae70]{background:var(--tbc-blue);transition:.4s}.circle[data-v-aff1ae70]{transform:translate(2px,2px);width:14px;height:14px;border-radius:50%;transition:.4s;background:#fff}.circle.active[data-v-aff1ae70]{transform:translate(18px,2px);transition:.4s;background:#1d2934}", ""]);
// Exports
module.exports = exports;
